import './form-billing.scss';
import { useFormContext } from "react-hook-form";
import { BillingFormSchema } from "@factory/form/form.rule";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";

type InputFormSchema = BillingFormSchema;
export function FormBilling() {
  const { control } = useFormContext<BillingFormSchema>();
  return (
    <div id="FormBilling" className="billing">
      <InputControl<InputFormSchema>
        control={control}
        name="contract"
        label="Contract"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter contract"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="session"
        label="Session"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter session"
      />
    </div>
  );
}

export default FormBilling;